import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const updateCategoryAction = createAsyncThunk(
  "update-category",
  async (data = null, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/admin/product/category`, {
        catId: data?.catId,
        name: data?.name,
        cashback_percentage: data?.cashback_percentage,
        position:data?.position,
        image:data?.image
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const updateCategorySlice = createSlice({
  name: "update-category",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(updateCategoryAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCategoryAction.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      if(state.status==401){
        localStorage.clear()
      }
      state.data = action.payload?.response;
    });
    builder.addCase(updateCategoryAction.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      state.error = action.error.message;
    });
  },
});

export const updateCategoryReducer = updateCategorySlice.reducer;
